import { render, staticRenderFns } from "./Bahn1Anmeldung.vue?vue&type=template&id=2d885816&scoped=true&"
import script from "./Bahn1Anmeldung.vue?vue&type=script&lang=js&"
export * from "./Bahn1Anmeldung.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1Anmeldung.vue?vue&type=style&index=0&id=2d885816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d885816",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VRadio,VRadioGroup,VTextField})
